<template>
  <FlickitySlider class="similarAccommodationsSlider__Listing mediumArrows" :options="flickityOptions" :with-progress="true" customClass="similarAccommodationsSlider__Flickity" :min-number-of-slides="3">
    <div v-for="item in locations" class="similarAccommodationsSlider__Item">
      <template v-if="Object.keys(item).length">
        <div class="imageWrap">
          <FlarePicture
            v-if="item.gallery?.[0]"
            :src="{
              1920: { src: item.gallery[0].image, width: 600, height: 450, size: 'both', crop: 'fill' },
            }"
            :alt="item.gallery[0].image.alt"
          />
  
          <FlarePicture
            class="imageWrap__OverlayImage"
            v-if="item.overlay_image"
            :src="{
              120: { src: item.overlay_image, width: 120, height: 80, size: 'both', crop: 'fit' },
            }"
            :alt="item.overlay_image.alt"
          />
        </div>
  
        <div class="infosWrap">
          <div class="similarAccommodationsSlider__Infos">
            <div class="similarAccommodationsSlider__Location">
              <Icon name="location" />
              <template v-if="item.place?.name">{{ item.place.name }}</template><template v-if="item.region?.name">, {{ item.region.name }}</template>
            </div>
  
            <div class="similarAccommodationsSlider__Stars">
              <img v-for="i in item.category_rating" src="/resources/images/icons/star.svg" width="14" height="14" alt="Star" />
            </div>
          </div>
          
          <h3 v-text="item.name" />
  
          <div v-if="item.price_end_of_year?.price_from" class="similarAccommodationsSlider__PriceWrapper">
            {{ $t('from') }} {{ formatPrice(item.price_end_of_year.price_from, item.price_end_of_year.currency, lang, true) }} <template v-if="item.price_from_description">{{ item.price_from_description }}</template>
          </div>
        </div>
        
        <nuxt-link :to="item.sef">{{ item.name }}</nuxt-link>
      </template>
    </div>
  </FlickitySlider>
</template>


<script setup>
  const props = defineProps({
    locations: {},
    flickityOptions: {
      type: Object
    }
  })

  const { lang } = useLanguage();
</script>

<style lang="scss">
  @import url('@/assets/styles/components/_similarAccommodationsSlider.scss');
</style>